/**
 * @description 返回本次页面是否允许在服务端读取公开业务内容。
 * @returns {import('vue').Ref<boolean>}
 * @reason 框架 SSR 与业务数据 SSR 独立控制；默认只渲染页面壳，业务数据由浏览器恢复。
 * @warning 在 Axios 并发注册表完成请求级隔离前不要开启内容 SSR，否则同名 concurrencyKey
 * 可能在共享 Node worker 中跨访客互相取消。
 */
export const usePublicContentSsrEnabled = () => {
  return useState('public-content-ssr-enabled', () => {
    if (import.meta.client) return false
    return useRuntimeConfig().contentSsrEnabled === true
  })
}

/**
 * @description 将公开内容 useAsyncData 约束为仅在内容 SSR 开启时自动执行。
 * @param {Record<string, unknown>} options - 原始 useAsyncData 选项
 * @returns {Record<string, unknown>}
 * @reason 同时关闭客户端 immediate，避免 hydration 阶段自动请求与 onMounted 恢复入口重复取数。
 */
export const usePublicContentAsyncDataOptions = (options = {}) => {
  const enabled = usePublicContentSsrEnabled()
  const allowServer = options.server !== false
  const allowImmediate = options.immediate !== false

  return {
    ...options,
    server: enabled.value && allowServer,
    immediate: enabled.value && allowImmediate,
  }
}
